import { BusinessUnitEmailContactService } from '../model/business-unit-email-contact.service';
import { CrudDataSource, HateoasMultipleResponseObject, PageSpecification } from '@scisys-uim/uim-common';
import { BusinessUnitEmailContact } from 'assets-model';
import { Observable } from 'rxjs';


export class BusinessUnitEmailContactDataSource extends CrudDataSource<BusinessUnitEmailContact> {

  constructor(private service: BusinessUnitEmailContactService) {
    super();
  }

  protected callLoaderService(serviceArguments: any, pageSpec: PageSpecification): Observable<HateoasMultipleResponseObject<BusinessUnitEmailContact>> {
    return this.service.findByFullFilters(serviceArguments, pageSpec);
  }

}


